import React from 'react';
import { Link } from 'react-router-dom';
import { withQuickSub } from 'decorators/withSub';
import { getSubStatus } from 'helpers/subs';
import { capitalize } from 'helpers/strings';

const PortLink = ({ show, to, text }) => {
  if (!show) {
    return null;
  }

  return (
    <Link className="mar-l" to={to}>
      <button className="btn btn-default">
        <img
          src="/images/icons/subActions/link-icon.svg"
          alt=""
          style={{ width: '16px', marginRight: '5px', marginBottom: '2px' }}
        />
        {text}
      </button>
    </Link>
  );
};

const component = ({
  sub,
  isBackToSub = true,
  isPortInLinks = false,
  showNetwork,
}) => {
  const subStatus = getSubStatus(sub);
  const showNewPort = [
    'new',
    'rejected',
    'port_error',
    'port_cancelled',
  ].includes(subStatus);
  const showUpdatePort = ['port_open', 'port_error'].includes(subStatus);
  const showPortCancel = ['port_open', 'port_error'].includes(subStatus);
  return (
    <div className="SubNav">
      <div className="flex-justify-space-between d-flex-vc">
        <div>
          <h3>
            {sub?.first_name} {sub?.last_name}
            {showNetwork && sub && sub.plan && (
              <React.Fragment>
                {' '}
                -{' '}
                <span>
                  {capitalize(sub.plan.network)}
                  {sub.plan.vendor && `(${sub.plan?.vendor?.toUpperCase()})`}
                </span>
              </React.Fragment>
            )}
          </h3>
          <p className="links">
            {isBackToSub ? (
              <Link to={`/quick/subscriptions/${sub?.id}/view`}>
                &larr; Back to Sub
              </Link>
            ) : (
              <Link to={`/users/${sub?.user_profile}/view`}>
                &larr; Back to User
              </Link>
            )}
          </p>
        </div>
        {isPortInLinks && (
          <div>
            <PortLink
              show={showNewPort}
              to={`/quick/subscriptions/${sub.id}/new-port`}
              text="New Port"
            />
            <PortLink
              show={showUpdatePort}
              to={`/quick/subscriptions/${sub.id}/update-port`}
              text="Update Port"
            />
            <PortLink
              show={showPortCancel}
              to={`/quick/subscriptions/${sub.id}/port-cancel`}
              text="Port Cancel"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export const SubNav = component;
export default withQuickSub(component);
